import React, { useEffect } from 'react'
import { trackEvent } from 'analytics/trackFunctions'
import TermsConditionsContent from 'components/termsConditionsContent/termsConditionsContent'
import PageWrapper from '../../components/PageWrapper'

export default function TermsConditions() {
  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_tyc' })
  }, [])

  return (
    <PageWrapper title='Términos y condiciones'>
      <div className='md:w-3/5 my-0 mx-auto mt-14'>
        <TermsConditionsContent />
      </div>
    </PageWrapper>
  )
}
